import React, { useEffect, useState } from 'react';
import Layout from '../../elements/Layout';
import { fetchProjects } from '../../utils/api/api';
import toast from 'react-hot-toast';
import Loading from '../../elements/Loading';
import { FaEye } from 'react-icons/fa6';
import { FaProjectDiagram, FaSpinner, FaPause, FaCheckCircle } from 'react-icons/fa';


const LandProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [projectsPerPage] = useState(20);

  const getProjects = async () => {
    setLoading(true);
    try {
      const data = await fetchProjects('land');
      setProjects(data.projects);
      setLoading(false);
    } catch (err) {
      toast.error('Failed to fetch Projects.');
      setLoading(false);
    }
  };

  useEffect(() => {
    getProjects();
  }, []);
  const stats = [
    { title: "Total Projects", value: 4378, icon: <FaProjectDiagram /> },
    { title: "In Progress", value: 7854, icon: <FaSpinner /> },
    { title: "On Hold", value: 872, icon: <FaPause /> },
    { title: "Complete Projects", value: 548, icon: <FaCheckCircle /> },
  ];
  const statStyles = [
    { bg: "from-blue-500 to-blue-200", iconBg: "bg-blue-600 text-white" },
    { bg: "from-green-500 to-green-200", iconBg: "bg-green-600 text-white" },
    { bg: "from-yellow-500 to-yellow-200", iconBg: "bg-yellow-600 text-white" },
    { bg: "from-purple-500 to-purple-200", iconBg: "bg-purple-600 text-white" },
  ];

  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = projects.slice(indexOfFirstProject, indexOfLastProject);
  const totalPages = Math.ceil(projects.length / projectsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Layout text={"Projects"} backgroundColor='bg-gray-50'>
      {loading && <Loading />}
      <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-4">
        {
          stats.map((stat, index) => (
            <div
              key={index}
              className={`w-full rounded-lg p-5 flex flex-col gap-3 bg-gradient-to-r ${statStyles[index].bg}  transform transition-transform duration-300 hover:scale-105`}
            >
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-full ${statStyles[index].iconBg}`}>
                  {stat.icon}
                </div>
                <span className="text-white text-[14px] font-medium">{stat.title}</span>
              </div>
              <hr className="border-white/50" />
              <p className="text-white text-[18px] font-semibold">{stat.value.toLocaleString()}</p>
            </div>
          ))
        }
      </div>
      <div className="w-full bg-gray-100 rounded-lg mt-4 p-4">
        {currentProjects.length === 0 ? (
          <div className="text-center text-gray-500">No projects found</div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-gray-500">
                <thead className="text-gray-700 uppercase bg-gray-50">
                  <tr>
                    <th scope="col" className="px-4 py-2 text-start">Title</th>
                    <th scope="col" className="px-4 py-2 text-start">Status</th>
                    <th scope="col" className="px-4 py-2 text-start">Price</th>
                    <th scope="col" className="px-4 py-2 text-start">Location</th>
                    <th scope="col" className="px-4 py-2 text-start">Listed On</th>
                    <th scope="col" className="px-4 py-2 text-start">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentProjects.map((project) => (
                    <tr
                      key={project.id}
                      className="bg-white border-b hover:bg-gray-50 transition-colors cursor-pointer"
                      onClick={() => window.location.assign(`/dashboard/projects/${project.id}/view`)}
                    >
                      <td className="px-4 py-2 font-medium text-gray-900 uppercase">{project.title}</td>
                      <td className="px-4 py-2">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium ${project.status === 'completed'
                            ? 'bg-green-100 text-green-600'
                            : project.status === 'in_progress'
                              ? 'bg-yellow-100 text-yellow-600'
                              : project.status === 'on_hold'
                                ? 'bg-red-100 text-red-600'
                                : 'bg-gray-200 text-gray-600'
                            }`}
                        >
                          {project.status.replace('_', ' ')}
                        </span>
                      </td>
                      <td className="px-4 py-2">KES {Number(project.price).toLocaleString()}</td>
                      <td className="px-4 py-2">{project.location}</td>
                      <td className="px-4 py-2">{new Date(project?.createdAt).toLocaleDateString()}</td>
                      <td className="px-4 py-2 text-right">
                        <button
                          className="text-black bg-secondary py-1 px-2 rounded-md hover:text-primary flex items-center text-xs gap-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.location.assign(`/dashboard/projects/${project.id}/view`);
                          }}
                        >
                          View <FaEye size={12} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {currentProjects.length > 0 && (
              <div className="w-full flex justify-end mt-4">
                <button
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="text-gray-500 hover:text-gray-700 flex items-center gap-1"
                >
                  Prev
                </button>
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => paginate(i + 1)}
                    className={`px-3 py-1.5 mx-1 text-sm font-medium ${currentPage === i + 1 ? 'bg-primary text-white' : 'text-primary'
                      } rounded-md`}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="text-gray-500 hover:text-gray-700 flex items-center gap-1"
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </Layout>
  );
};

export default LandProjects;
